import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {}

    jumpToTarget(event) {
        event.preventDefault();

        const link = event.currentTarget;
        const marker = link.getAttribute("data-marker");
        if (!marker) return;

        let targetKey = marker;
        let targetIndex = 0;

        if (marker.includes(".")) {
            const parts = marker.split(".");
            targetKey = parts[0];
            targetIndex = parseInt(parts[1], 10) || 0;
        }

        const containers = Array.from(document.querySelectorAll("[data-jumpmarker]")).filter(
            el => el.getAttribute("data-jumpmarker")?.includes(targetKey)
        );

        if (!containers.length) return;

        const targetElement = containers[targetIndex];
        if (!targetElement) return;

        const header = document.querySelector(".header");
        const headerOffset = header?.offsetHeight || 0;

        const currentScroll = window.scrollY;
        const targetTop = targetElement.getBoundingClientRect().top + window.scrollY;

        const isScrollingUp = targetTop < currentScroll;
        const targetPosition = isScrollingUp
            ? targetTop - headerOffset
            : targetTop;

        window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
        });
    }

}
